import { Box, Typography } from "@mui/material";
import type { FocusedConversationInsights } from "components/Conversations/FocusedConversationInsights";
import { observer } from "mobx-react";
import React from "react";
import KeyInsight from "./KeyInsights/KeyInsight";

type KeyInsightsProps = {
    insights: FocusedConversationInsights;
};

const KeyInsightsContainer: React.FC<KeyInsightsProps> = observer(
    ({ insights }) => (
        <Box>
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    marginBottom: 1,
                }}
                component="div"
            >
                {insights.title}
            </Typography>
            {insights.items.length > 0 ? (
                <Box
                    sx={{
                        backgroundColor: "#E5E7EB",
                        borderRadius: "4px",
                        padding: 1,
                    }}
                >
                    {insights.items.map((insight, index) => (
                        <KeyInsight
                            key={`${index}-${insight.name}`}
                            name={insight.name}
                            description={insight.description}
                        />
                    ))}
                </Box>
            ) : (
                <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#D1D5DB" }}
                >
                    {insights.emptyMessage}
                </Typography>
            )}
        </Box>
    ),
);

export default KeyInsightsContainer;
